var _style, _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download_svg__Icons",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    stroke: "currentColor"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".download_svg__st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "download_svg__st0",
    cx: 16,
    cy: 13,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "download_svg__st0",
    d: "M10 15.9c-1.9 1.5-3.4 3.6-4 6.1h2.3c1.5 0 2.6-1.4 2.2-2.8-.4-1.4-.6-2.8-.6-4.3C10 9.4 12.5 4.7 16 3c3.5 1.7 6 6.4 6 11.8 0 1.5-.2 3-.6 4.3-.4 1.4.7 2.8 2.2 2.8H26c-.6-2.5-2.1-4.7-4-6.1M16 22v8M13 24v4M19 24v4"
  })));
}

export default __webpack_public_path__ + "assets/31216213638019686b077a4fcf0f93fd.svg";
export { SvgDownload as ReactComponent };